<template>
	<div class="divide-y">
		<div class="flex items-center pl-4 py-2" :class="[isForecast ? 'grid-cols-9' : 'grid-cols-7']" v-for="product in order">
			<div class="flex-1">{{ product.name }} <span class="text-sm text-white">{{ product.id }}</span></div>
			<div class="w-20 flex-shrink-0 text-center" v-if="isForecast">{{ product.allocated }}</div>
			<!-- <div class="w-20 flex-shrink-0 text-center">{{ (product.allocated - product.used) <= 0 ? 0 : product.stock_qty }}</div> -->
			<div class="w-20 flex-shrink-0 text-center">{{ product.stock_qty > 0 ? product.forecast_received - product.forecast_ordered : 0 }}</div>
			<div class="w-20 flex-shrink-0 text-center">{{ product.forecasted - product.used }}</div>
			<div class="w-32 flex-shrink-0 text-right">
				<input :ref="`unit_${unit}_${product.id}`" v-if="canEditQty(product)" class="w-12 sm:w-24 text-base appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="text" @input="modifyProductQty(product, $event, 'Unit')" v-model="product.qty" placeholder="qty">
				<check-circle-icon class="w-4 h-4 inline-block text-green-400 mr-2" v-if="isComplete(product)"></check-circle-icon>
				<template v-if="!isForecast">
					<clock-icon class="w-4 h-4 inline-block text-blue-400 mr-2" v-if="product.stock_qty == 0 && product.forecasted > product.used"></clock-icon>
					<alert-circle-icon class="w-4 h-4 inline-block text-red-400 mr-2" v-if="product.forecasted < product.allocated && product.stock_qty == 0"></alert-circle-icon>
				</template></div>
		</div>
	</div>
</template>

<script>
	export default {

		name: 'OrderUnitComponent',

		props: ['phase','block','unit','toggle'],

		data () {
			return {
				products: [],
				order: [],
				location: '',
			}
		},
		computed: {
			isForecast: function(){
				return this.location == 'Forecast Order';
			},
			notForecast: function(){
				return !this.isForecast;
			},
			availableProducts: function() {
				return this.products.filter(product => {
					if(this.isForecast){
						return product.remaining - product.forecasted > 0;
					}
				})
			}
		},
		watch: {
			'toggle': function(newVal, OldVal) {
				this.ToggleUnit(newVal);
			}
		},
		methods: {
			canEditQty: function(product){
				if(this.notForecast){
					return (product.allocated - product.used > 0)
						&& product.stock_qty > 0
							&& product.forecast_received - product.forecast_ordered > 0;
				}
				return (product.allocated - product.forecasted) > 0;
			},
			canSelectUnit: function(unit){
				if(this.notForecast){
					return unit.order_done=='n' && unit.forecast_done=='y'
				}
				return unit.forecast_done=='n';
			},
			isComplete: function(product){
				return (product.allocated - product.used) <= 0 && product.forecasted > 0;
			},
			ToggleUnit: function(state){
				if(state){
					this.order.forEach(product => {
						if(this.isForecast){
							product.qty = product.allocated - product.forecasted;
						}else{
							if(product.allocated > product.used && product.allocated <= product.forecast_received){
								let available = (product.forecast_received - product.used)
								product.qty = available;
							}
						}
					});
					let keyedOrder = this.$_.reduce(this.order, function(result, value, key) {
						result[value.id] = value.qty;
						return result;
					}, {});
					this.$store.commit('order/addUnit', {
						'unitId': this.unit,
						'products': keyedOrder
					});
				}else{
					this.order.forEach(product => {
						product.qty = null;
					});
					this.$store.commit('order/removeUnit', {
						'unitId': this.unit
					});
				}
			},
			modifyProductQty: function(product, event, type){
				let newVal = event.target.value;
				if(this.isForecast && (newVal > (product.allocated - product.forecasted))){
					newVal = product.allocated - product.forecasted;
				}
				if(this.notForecast && (newVal > (product.forecast_received - product.forecast_ordered))){
					newVal = product.forecast_received - product.forecast_ordered;
				}
				this.$store.commit('order/modifyProductQty', {
					'unitId': this.unit,
					'productId': product.id,
					'qty': newVal,
					'type': type
				});
				this.$nextTick(() => {
					event.target.value = newVal;
				});
			},
		},
		mounted () {
			this.location = this.$route.name;
			var jobId = this.$route.params.id;
			this.$http.get(`jobs/${jobId}/phases/${this.phase}/blocks/${this.block}/units/${this.unit}`)
				.then(response => {
					let existing = this.$store.getters['order/getOrder'];
					this.products = response.data.productslist;
					this.order = this.$_.reduce(this.products, (result, value, key) => {
						let product = (({ id, name, allocated, forecasted, forecast_received, forecast_ordered, pack_size, pdt_status, stock_qty, unit_measure, used }) => ({ id, name, allocated, forecasted, forecast_received, forecast_ordered, pack_size, pdt_status, stock_qty, unit_measure, used }))(value);
						product.productId = value.id;
						if(existing.units[this.unit]){
							existing.units[this.unit].forEach(set => {
								if(set[value.id]){
									product.qty = set[value.id];
								}
							});
						}else{
							product.qty = null;							
						}
						result.push(product);
						return result;
					}, []);
				})
				.catch(err => {
					this.error = err
				})
				.finally(() => {
					// this.$store.commit('forecast/emptyStore');
					// this.$store.commit('order/emptyStore');
				});
				// forEach(existing.units[this.unit], (set, index) => {
				// 				console.log(set);
				// 				if(Object.keys(set[0]) == value.id){
				// 					product.qty = existing.units[this.unit][value.id];

				// 				}
				// 			});
		}
	}
</script>

<style lang="css" scoped>
</style>